export const Heart = ({ className = "w-3.5 h-3.5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="#C13B2E" aria-hidden="true">
    <path d="M12 21s-7.5-4.9-10-9.2C.4 8.6 2.3 5 5.7 5c2 0 3.3 1.1 4 2.2L12 9l2.3-1.8C15 6.1 16.3 5 18.3 5c3.4 0 5.3 3.6 3.7 6.8C19.5 16.1 12 21 12 21z" />
  </svg>
);

export const Logo = ({ onDark = false, className = "h-14" }) => (
  <img
    src="/assets/sipsation-logo.png"
    alt="Sipsation — Beans Brew Books"
    className={`${className} w-auto select-none ${onDark ? "brightness-0 invert" : ""}`}
    draggable="false"
  />
);
